import accountDetails from './accountDetails.json';
import authentication from './authentication.json';
import common from './common.json';
import editParts from './editParts.json';
import instructions from './instructions.json';
import manageProduct from './manageProduct.json';
import myAccount from './myAccount.json';
import navigation from './navigation.json';
import orders from './orders.json';
import partsCatalogue from './partsCatalogue.json';
import productLibrary from './productLibrary.json';
import shoppingCart from './shoppingCart.json';
import threeDWidget from './threeDWidget.json';
import uploads from './uploads.json';
import workInstructions from './workInstructions.json';

export default {
  common,
  authentication,
  orders,
  myAccount,
  navigation,
  productLibrary,
  workInstructions,
  threeDWidget,
  shoppingCart,
  accountDetails,
  uploads,
  partsCatalogue,
  editParts,
  manageProduct,
  instructions,
};
